import {IShopRatingSummary} from "@connox/typescript-library";
import React, {Component} from "react";
import {WithTranslation, withTranslation} from "react-i18next";
import styled from "styled-components";
import {spacing} from "../../theme";

const RatingAverage = styled.div`
  float: left;
  display: inline-block;
  width: auto;
  margin-right: ${spacing};
  margin-bottom: ${spacing};
  font-size: 1em;
  line-height: 1.5em;
  @media (min-width: 1120px) {
    font-size: 0.9em;
  }
`;

const StarsLabel = styled.span`
  width: 5em;
  display: inline-block;
`;

const BlueBar = styled.span`
  background-color: #1ba1e2; //Not default blue
  display: inline-block;
  height: 8px;
  overflow: hidden;
`;

export const GreyBar = styled(BlueBar)`
  background-color: #ddd;
`;

interface IShopRatingSummaryProps extends WithTranslation {
  summary: IShopRatingSummary;
  showStats: boolean;
}

class ShopRatingSummary extends Component<IShopRatingSummaryProps> {
  private readonly sum: number;
  private average: number;

  constructor(props: IShopRatingSummaryProps) {
    super(props);
    // Calculating average Stars
    // (ref: https://stackoverflow.com/questions/10196579/algorithm-used-to-calculate-5-star-ratings)

    this.sum =
      this.props.summary["5"] +
      this.props.summary["4"] +
      this.props.summary["3"] +
      this.props.summary["2"] +
      this.props.summary["1"];

    this.average =
      (5 * this.props.summary["5"] +
        4 * this.props.summary["4"] +
        3 * this.props.summary["3"] +
        2 * this.props.summary["2"] +
        this.props.summary["1"]) /
      this.sum;
  }

  public render() {
    const {average, props, sum} = this;
    const {showStats, summary, t} = props;

    const avg = average ? Math.round(average) : 0;
    const doubleAverage = Math.round(average * 2);

    const summaryElements: JSX.Element[] = [];
    for (let star = 5; star > 0; star--) {
      if (!summary.hasOwnProperty(star)) {
        continue;
      }
      const ratingsForStars = summary[star] as number;
      summaryElements.push(
        <div key={`star${star}`}>
          <StarsLabel key={star}>{t("{{star}} Sterne", {star})}</StarsLabel>
          &nbsp;
          <BlueBar style={{width: Math.round((ratingsForStars / sum) * 50)}}>&nbsp;</BlueBar>
          <GreyBar style={{width: 50 - Math.round((ratingsForStars / sum) * 50)}}>&nbsp;</GreyBar> ({ratingsForStars})
        </div>,
      );
    }

    const Rating = styled.div`
      display: flex;

      .rating__summary {
        flex: 0 0 180px;
        margin: 0 1rem 1rem 0;
        @media (max-width: 350px) {
          margin: 0 0 1rem;
        }
      }
    `;

    return (
      <>
        {showStats ? (
          <Rating>
            <div className={"rating__summary"}>{summaryElements}</div>
            <RatingAverage>
              <span className={`sprite sprite-link sprite-stars-big-${doubleAverage}`}>
                {t("{{rating}} von 5 Sternen", {rating: avg})}
              </span>{" "}
              {sum ? t("{{sum}} Bewertungen", {sum}) : t("Laden...")}
              <br />
              <br />
            </RatingAverage>
          </Rating>
        ) : (
          <>
            <span className={`sprite sprite-link sprite-stars-big-${doubleAverage}`}>
              {t("{{rating}} von 5 Sternen", {rating: avg})}
            </span>
            &nbsp;({sum ? sum.toString().trim() : t("Laden...")})
          </>
        )}
        <br />
      </>
    );
  }
}

export default withTranslation()(ShopRatingSummary);
